import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Shadow Council Initiation',
		description:
			"Establish a council so secret that even its members don't know they're in it."
	},
	{
		name: 'Invisible Hierarchy',
		description:
			"Create an organizational structure so complex that it technically doesn't exist."
	},
	{
		name: 'Quantum Bureaucracy',
		description:
			'All paperwork exists in a state of quantum uncertainty until audited.'
	},
	{
		name: 'Recursive Conspiracy',
		description:
			'Create a conspiracy theory about your own conspiracy theories.'
	},
	{
		name: 'Temporal Infiltration',
		description:
			"Plant deep state operatives throughout history. They've always been there."
	},
	{
		name: 'Multiverse Manipulation',
		description:
			"Control every parallel universe simultaneously. They're all cake."
	},
	{
		name: 'Void Administration',
		description:
			'Outsource operations to the void. Very cost-effective, slightly existential.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Deep State Ventures'],
	departments[DepartmentIds['Deep State Ventures']].basePrice * 3,
	UpgradeIds.DsvExponent1
)

export default array
